import { Http } from '@mygpt/app/http';

import { RobotList } from '../store';

export interface RobotListParams {
  page: number;
  size: number;
  search?: string;
  // 公司ID：不传或为空表示个人资产，传组织ID表示组织资产
  company_id?: string;
  tag_ids?: string[];
  include_counts?: boolean;
}

/**
 * 用户机器人列表项
 */
export interface UserBotsItem {
  user_id: string;
  bots: string[];
}

/**
 * 用户机器人列表（通过 user_ids 参数获取）
 */
export type UserBotsList = UserBotsItem[];

/**
 * 我的机器人列表
 * @param params
 * @param config 可选配置：支持 AbortSignal 取消请求
 * @returns
 */
export const getRobotList = (params: RobotListParams, config?: { signal?: AbortSignal }) => {
  const { search, tag_ids, company_id, ...rest } = params;
  const { get } = Http.use();

  // Build params object, only include search if it has a value
  const queryParams = {
    ...rest,
    ...(search && search.trim() && { search: search.trim() }),
    ...(company_id && { company_id }),
    ...(tag_ids && tag_ids.length > 0 && { tag_ids }),
  };

  return get<RobotList>(`/robots`, {
    params: queryParams,
    paramsSerializer: {
      indexes: null, // 将数组参数序列化为 tag_ids=value1&tag_ids=value2
    },
    signal: config?.signal,
  });
};

/**
 * 根据用户ID列表获取用户的机器人列表
 * @param userIds 用户ID数组
 * @returns 用户机器人列表
 */
export const getUsersBots = (userIds: string[]) => {
  const { get } = Http.use();

  return get<UserBotsList>(`/robots`, {
    params: {
      user_ids: userIds,
    },
    paramsSerializer: {
      indexes: null, // 将数组参数序列化为 user_ids=value1&user_ids=value2
    },
  });
};
